const GRAVADO_A_GRAVADO = '1'
const GRAVADO_A_NO_GRAVADO = '2'
const NO_GRAVADO = '3'
const OTROS = '5'
const GRAVADO_A_AMBOS = '6'
const RECIBO_HONORARIOS = '7'
const ISC = '-I'

const __dictionary = {
  [GRAVADO_A_GRAVADO]: {
    id: GRAVADO_A_GRAVADO,
    nombre: '1 - GRAVADO A GRAVADO'
  },
  [GRAVADO_A_NO_GRAVADO]: {
    id: GRAVADO_A_NO_GRAVADO,
    nombre: '2 - GRAVADO A NO GRAVADO'
  },
  [NO_GRAVADO]: {
    id: NO_GRAVADO,
    nombre: '3 - NO GRAVADO'
  },
  [OTROS]: {
    id: OTROS,
    nombre: '5 - OTROS'
  },
  [GRAVADO_A_AMBOS]: {
    id: GRAVADO_A_AMBOS,
    nombre: '6 - GRAVADO A AMBOS'
  },
  [RECIBO_HONORARIOS]: {
    id: RECIBO_HONORARIOS,
    nombre: '7 - RH'
  },
  [ISC]: {
    id: ISC,
    nombre: '-I - ISC'
  }
}

const __array = [
  __dictionary[GRAVADO_A_GRAVADO],
  __dictionary[GRAVADO_A_NO_GRAVADO],
  __dictionary[NO_GRAVADO],
  __dictionary[OTROS],
  __dictionary[GRAVADO_A_AMBOS],
  __dictionary[RECIBO_HONORARIOS],
  __dictionary[ISC]
]

export default Object.freeze({
  GRAVADO_A_GRAVADO,
  GRAVADO_A_NO_GRAVADO,
  NO_GRAVADO,
  OTROS,
  GRAVADO_A_AMBOS,
  RECIBO_HONORARIOS,
  ISC,
  __dictionary,
  __array
})
